import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { PanelProps } from './types.js';

/** `<Panel>` component. */
export const Panel = ({ children, className, ...props }: PanelProps): ReactElement => (
  <div className={twMerge('flex w-full flex-1 min-h-0 flex-col gap-32', className)} {...props}>
    {children}
  </div>
);
